var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledgeBaseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34531 2.63387C7.43525 2.68 7.52439 2.72828 7.61265 2.77871L8 3.00005L8.38735 2.77871C8.47561 2.72828 8.56475 2.68 8.65469 2.63387C10.5465 1.66373 12.7942 1.64715 14.7065 2.60331C15.1928 2.84646 15.5 3.3435 15.5 3.88719V12.8254C15.5 13.4741 14.9741 14.0001 14.3254 14.0001H14.2845C14.0983 14.0001 13.9157 13.9495 13.7561 13.8537C12.3509 13.0106 10.6124 12.9438 9.14676 13.6767L8.94721 13.7764C8.88283 13.8086 8.81701 13.8375 8.75 13.8628C8.51091 13.9533 8.25683 14.0001 8 14.0001H7.88327C7.66535 14.0001 7.45002 13.9562 7.25 13.8715C7.21867 13.8582 7.18772 13.8439 7.15719 13.8287L6.9242 13.7122C5.41433 12.9572 3.62342 13.026 2.1759 13.8945C2.0608 13.9636 1.92909 14.0001 1.79486 14.0001H1.67464C1.02591 14.0001 0.5 13.4741 0.5 12.8254V3.88719C0.5 3.3435 0.807183 2.84646 1.29348 2.60331C3.20582 1.64715 5.45355 1.66373 7.34531 2.63387ZM8.75 12.2061V4.29911L9.13156 4.08108C10.6292 3.22529 12.4529 3.16845 14 3.92727V12.284C12.35 11.4964 10.4315 11.464 8.75 12.2061ZM7.25 12.2105V4.29911L6.86844 4.08108C5.37082 3.22529 3.54709 3.16845 2 3.92727V12.2919C3.65407 11.5219 5.56451 11.4886 7.25 12.2105Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBaseIcon);
export default __webpack_public_path__ + "static/media/KnowledgeBaseIcon.0576f7711a4157b95a48d73a9125b9c1.svg";
export { ForwardRef as ReactComponent };